import {
  BFF_ROUTES,
  NewServiceDeclareResponseSchema,
  NewServiceStatusResponseSchema,
  type NewServiceDeclareRequest,
  type NewServiceDeclareResponse,
  type NewServiceStatusResponse,
} from '@rheora/enrollment-contract';

import { bffGet, bffPost } from './bff-client';

/**
 * Typed fetchers for E-SF20 — new service establishment (new construction, no ESI
 * ID yet). Thin: build the path, validate against the shared contract schema,
 * return. Pages never import these — the queries layer wraps them.
 *
 * ── PUBLIC POSTURE ─────────────────────────────────────────────────────────
 * Credential-free (`bff-client`): no Authorization, no x-tenant-id. The declare
 * POST rides the funnel session established by the address lookup that sent the
 * customer here; the status GET carries nothing at all — the ref IS the
 * capability, exactly like the enrollment status token.
 */

/** `POST /bff/new-service/declare` — record a build the customer says is coming. */
export async function postNewServiceDeclare(
  request: NewServiceDeclareRequest,
): Promise<NewServiceDeclareResponse> {
  return bffPost(BFF_ROUTES.newServiceDeclare, request, NewServiceDeclareResponseSchema);
}

/**
 * `GET /bff/new-service/:ref` — the anonymous pending-service status read.
 *
 * The ref is path-interpolated and MUST be encoded: it is base64url and therefore
 * already path-safe, but encoding it here means a malformed ref pasted from an
 * email cannot alter the request path — it just 404s, which is the uniform answer
 * the BFF gives every unknown ref.
 */
export async function getNewServiceStatus(ref: string): Promise<NewServiceStatusResponse> {
  const path = BFF_ROUTES.newServiceStatus.replace(':ref', encodeURIComponent(ref));
  return bffGet(path, NewServiceStatusResponseSchema);
}
